import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventqActionLoader, EventqDialogPopover } from '@ecam/eventq-components';
import { isLoadingRoutePath } from '../../../../core/routing/browser-tab-routes';
import { BrowserTabNavigationService } from '../../../../core/services/browser-tab-navigation.service';
import { BrowserTabService } from '../../../../core/services/browser-tab.service';
import { ActionLoadingService } from '../../services/action-loading.service';

@Component({
  selector: 'app-action-loading',
  imports: [EventqActionLoader, EventqDialogPopover],
  templateUrl: './action-loading.html',
  styleUrl: './action-loading.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionLoadingPage implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  private readonly tabNavigation = inject(BrowserTabNavigationService);
  private readonly browserTabs = inject(BrowserTabService);
  private readonly actionLoading = inject(ActionLoadingService);

  readonly message = this.route.snapshot.data['message'] as string;
  readonly startConflict = this.actionLoading.startConflict;

  onConflictDismiss(): void {
    void this.actionLoading.dismissStartConflict();
  }

  onConflictConfirm(): void {
    void this.actionLoading.confirmProcessQueuedEvent();
  }

  ngOnDestroy(): void {
    this.actionLoading.releaseStartConflict();
  }

  ngOnInit(): void {
    const pending = this.browserTabs.pendingAction();
    const routePath = this.browserTabs.getPageState(this.browserTabs.activeTabId()).routePath;

    if (pending) {
      void this.actionLoading.runLoadingFlow(pending);
      return;
    }

    if (isLoadingRoutePath(routePath)) {
      void this.actionLoading.recoverInterruptedLoad(routePath);
      return;
    }

    void this.tabNavigation.navigateWithinActiveTab();
  }
}
